<template> </template>

<script>
export default {
  name: "Invite"
};
</script>

<style scoped></style>
